import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  changePassword as changePasswordService,
  requestLink,
  verifyTokenValidation,
} from '../../services/resetPasswordService';
import validateEmail from '../../utils/emailValidator';

interface ParamTypes {
  token: string;
}

const ChangePassword = (props: any) => {
  const [email, setEmail] = useState('');
  const [newPass, setNewPass] = useState('');
  const [newPassConf, setNewPassConf] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [enableChangePasswordFields, setEnableChangePasswordFields] =
    useState(false);

  const { token } = useParams<ParamTypes>();
  const history = useHistory();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleNewPassChange = (event, type) => {
    const inputChange = type === 'newPass' ? setNewPass : setNewPassConf;
    inputChange(event.target.value.trim());
  };

  const sendRecoveryEmail = async (event) => {
    event.preventDefault();

    if (!email.trim() || !validateEmail(email)) {
      return toast.error('Por favor insira um email válido.');
    }

    try {
      await requestLink(email);
      setEmailSent(true);
    } catch (error) {
      error && error.response && error.response.data && error.response.data.msg
        ? toast.error(error.response.data.msg)
        : toast.error('Algo deu errado.');
    }
  };

  const changePassword = async (event) => {
    event.preventDefault();

    if (!newPass && !newPassConf) {
      return toast.error('Por favor preencha ambos os campos.');
    }

    if (newPass !== newPassConf) {
      return toast.error('As senhas devem ser iguais.');
    }

    if (newPass.length < 6) {
      return toast.error('A nova senha deve conter ao menos 6 caracteres.');
    }

    try {
      await changePasswordService(token, newPass);
      toast.success('Senha alterada com sucesso.');
      history.push('/login');
    } catch (error) {
      error.response.data.msg
        ? toast.error(error.response.data.msg)
        : toast.error('Não foi possível alterar a senha.');
    }
  };

  useEffect(() => {
    if (!props.forgotPage) {
      (async () => {
        await verifyTokenValidation(token);
        setEnableChangePasswordFields(true);
      })().catch((_err) => {
        toast.error('Token inválido. Redirecionando para login.');
        localStorage.removeItem('token');
        history.push('/login');
      });
    }
  }, []);

  return (
    <div className='login'>
      {emailSent && (
        <>
          <h4 style={{ textAlign: 'center', marginTop: '20px' }}>
            Email enviado com sucesso.
          </h4>
          <p style={{ textAlign: 'center' }}>
            O link enviado é válido por 30 minutos.
          </p>
        </>
      )}
      {props.forgotPage && !emailSent && (
        <Form onSubmit={sendRecoveryEmail} className='login-form'>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              onChange={handleEmailChange}
              type='text'
              placeholder='Insira seu e-mail'
            />
          </Form.Group>
          <div id='login-buttons'>
            <Button variant='primary' type='submit'>
              Enviar link
            </Button>
            <Button
              variant='secondary'
              onClick={() => history.push('/register')}
            >
              Cadastrar-se
            </Button>
          </div>
        </Form>
      )}
      {enableChangePasswordFields && (
        <Form onSubmit={changePassword} className='login-form'>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Nova senha</Form.Label>
            <Form.Control
              onChange={(event) => handleNewPassChange(event, 'newPass')}
              type='password'
              placeholder='Insira a nova senha'
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Confirmar nova senha</Form.Label>
            <Form.Control
              onChange={(event) => handleNewPassChange(event, 'newPassConf')}
              type='password'
              placeholder='Confirme a nova senha'
            />
          </Form.Group>
          <div id='login-buttons'>
            <Button variant='primary' type='submit'>
              Confirma mudança de senha
            </Button>
            <Button
              variant='secondary'
              onClick={() => history.push('/register')}
            >
              Cadastrar-se
            </Button>
          </div>
        </Form>
      )}
    </div>
  );
};

export default ChangePassword;
